import {
  LitElement,
  html,
  styleMap,
  property,
} from '@oskecare/fe-utilities/lib/LitElement/index.js';
import style from './style.scss';

/**
 * PageLoader component for displaying fancy loading strip
 *
 * Has two UIs, infinite loading pulse animation or progress bar based on provided percentage value
 */
class PageLoader extends LitElement {
  /**
   * Specifies UI of the element, if `true` PageLoader renders as infinite loading pulse animation
   *
   * @type {boolean}
   */
  @property({ type: Boolean, attribute: 'is-infinite' })
  accessor isInfinite = false;

  /**
   * Percentage of progress bar ought to be filled, possible values in range 0-100
   *
   * @type {number}
   */
  @property({ type: Number })
  accessor value = 0;

  static get styles() {
    return [style];
  }

  render() {
    return this.isInfinite
      ? html`
          <div class="page-loader fullwidth" aria-label="Prebieha načítanie informácií">
            <div class="page-loader__infinity">
              <div class="page-loader__infinity-bar"></div>
              <div class="page-loader__infinity-bar"></div>
            </div>
          </div>
        `
      : html`
          <div class="page-loader fullwidth">
            <div
              class="page-loader__progress"
              role="progressbar"
              style=${styleMap({ width: `${this.value}%` })}
              aria-valuenow=${this.value}
              aria-valuemin="0"
              aria-valuemax="100"
              aria-label="Prebieha načítanie informácií"
            ></div>
          </div>
        `;
  }
}

// In case of duplicate custom element registration due to multiple
// instances of the element used, we want to skip the second registration causing error.
if (!customElements.get('osk-page-loader')) {
  customElements.define('osk-page-loader', PageLoader);
}
